import { useRouter } from "next/router";
import React, { useContext, useState, useTransition } from "react";
import { useRef } from "react";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import notificationModel from "../../models/notifications.model";

import Heading from "../../components/Heading";
import helper from "../../lib/helper";
import dynamic from "next/dynamic";
import "react-quill/dist/quill.snow.css";
import _ from "lodash";

const ReactQuill = dynamic(() => import("react-quill"), {
  ssr: false,
});

const Page = function () {
  const editorRef = useRef(null);
  const router = useRouter();
  const [message, setMessage] = useState("");
  const [preview, setPreview] = useState(
    "http://ssl.gstatic.com/accounts/ui/avatar_2x.png",
  );
  const {
    register,
    handleSubmit,

    setValue,
    formState: { errors },
    setError,
  } = useForm();

  const onSelectFile = (e) => {
    console.log(e.target.files[0]);
    // I've kept this example simple by usin;g the first image instead of multiple
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    setPreview(objectUrl);
    //setValue("avatar", e.target.files[0]);
  };

  const onSubmit = handleSubmit(async (data, event) => {
    const formData = new FormData(event.target);
    formData.set("message", data.message);

    await notificationModel
      .create(formData)
      .then((response) => {
        console.log("FormData", formData);
        console.log("response", response);
        helper.sweetalert.toast(response.data?.message, "success");
        router.push("/notifications");
      })
      .catch((error) => {
        console.log(error.response.data.errors);
        helper.sweetalert.toast(error.response.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  return (
    <>
      <Heading title="Create Notification" />
      <form onSubmit={onSubmit} className="container-fluid">
        <div className="card col-md-12">
          <div className="card-header">Create Notification</div>
          <div className="card-body row">
            <div className="col-md-3 me-3 position-relative border-end">
              <img src={preview} className="w-100 border rounded" alt="" />
              <div className="m-1">
                <label className="custom-file-upload">
                  <input
                    type="file"
                    className="d-none"
                    accept="image/*"
                    {...register("avatar", { onChange: onSelectFile })}
                  />
                  <b className="btn btn-dark">Upload</b>
                </label>
              </div>
            </div>
            <div className="col-md-9 row">
              <div className="col-md-12 mt-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  placeholder="Enter title"
                  className={`form-control ${errors?.title && "is-invalid"}`}
                  {...register("title", {
                    required: "title is required",
                  })}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label">Message</label>

                <ReactQuill
                  theme="snow"
                  value={message}
                  placeholder="Enter message notification"
                  onChange={(value) => {
                    setMessage(value);

                    setValue("message", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],

                      ["bold", "italic", "underline", "strike"],

                      [{ color: [] }, { background: [] }],

                      [{ align: [] }],

                      [{ list: "ordered" }, { list: "bullet" }],

                      ["blockquote"],

                      ["link", "image"],

                      ["clean"],
                    ],
                  }}
                />

                {errors.message && (
                  <div className="invalid-feedback d-block">
                    {errors.message.message}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button type="submit" className="btn btn-primary float-end">
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Page;
